module.exports = __webpack_public_path__ + "906a161d8ea1663be3a9335969ebc004.svg";